import React, { Component } from 'react';
import MediaQuery from 'react-responsive';

import './Tools.css';
import LayoutGrid from './LayoutGrid';
import LayoutList from './LayoutList';
import SectionTitle from './SectionTitle';
import {
  DEVICE_THRESHOLD,
} from '../index';

const items = [{
  title: 'Geohash Plugin',
  content: 'An open source plugin that allows for the visualization of a geohash grid on the JOSM map and supports the search for a specific geohash unit.',
  link: {
    name: 'Learn More',
    url: 'https://wiki.openstreetmap.org/wiki/JOSM/Plugins/GeoHash',
    gaMessage: 'a link from the tools section',
  },
}, {
  title: 'KartaView',
  content: 'An open source / open data platform for capturing, storing, analyzing and serving street-level imagery for improving OpenStreetMap.',
  link: {
    name: 'KartaView.org',
    url: 'https://kartaview.org/',
    gaMessage: 'a link from the tools section',
  }
}];

class Tools extends Component {
  render() {
    return (
      <div id="lp-tools" className="lp-tools-container">
        <SectionTitle section="tools" text="Tools" />
        <div className="lp-below-title">
          <MediaQuery minWidth={DEVICE_THRESHOLD + 1}>
            <LayoutGrid items={items} hasBlogCell={false}/>
          </MediaQuery>
          <MediaQuery maxWidth={DEVICE_THRESHOLD} hasBlogCell={false}>
            <LayoutList items={items} />
          </MediaQuery>
        </div>
      </div>
    );
  }
}

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Tools.js